module.exports = __webpack_public_path__ + "static/img/tips.4672a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/tips.png
// module id = 5KHn
// module chunks = 6